export const queryKeys = {
  ALL_OTM_LIST_QUIZ: 'all-otm-royxati-quiz',
};
